import { render, staticRenderFns } from "./DeleteText.vue?vue&type=template&id=57cfafea&scoped=true"
import script from "./DeleteText.vue?vue&type=script&lang=js"
export * from "./DeleteText.vue?vue&type=script&lang=js"
import style0 from "./DeleteText.vue?vue&type=style&index=0&id=57cfafea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cfafea",
  null
  
)

export default component.exports